import React from "react";
import { View, StyleSheet, Text } from "@react-pdf/renderer";
import Title from "./Title";
import { globalStyles } from "../../views/Resume";

const styles = StyleSheet.create({
  skillContainer: {
    fontSize: 6,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
});

const Skills = ({ skills }) => (
  <View style={globalStyles.container}>
    <View>
      <Title>Technical Skills</Title>
    </View>
    <View>
      {skills.map((skill, index) => (
        <View
          key={skill.type}
          style={[
            styles.skillContainer,
            index !== skills.length - 1 && { marginBottom: "2px" },
          ]}
        >
          <Text style={globalStyles.bold}>{skill.type}: </Text>
          <Text style={styles.details}>{skill.skills.join(", ")}</Text>
        </View>
      ))}
    </View>
  </View>
);

export default Skills;
